<template>
    <div class="btn-group-wrapper">
        <div class="btn-group">
            <button v-for="button in buttons" :class="{selected: button.value === value}" @click="select(button.value)">{{button.title}}</button>
        </div>
    </div>

</template>

<script>
export default {
    name: "BtnGroup",
    props: {
        buttons: {
            type: Array,
            required: true
        },
        value: {
            type: String,
            required: true
        }
    },
    methods: {
        select(value){
            this.$emit('change', value)
        }
    }
}
</script>

<style lang="scss" scoped>
.btn-group-wrapper {
    display: flex;

    .btn-group {
        margin: 0 auto;
        background-color: #EAF1FC;
        border-radius: 50px;
        overflow: hidden;

        button {
            color: #2E76E4;
            border-radius: 50px;
            border: none;
            padding: 11px 30px;
            font-size: 14px;
            font-weight: bold;

            &.selected {
                color: #ffffff;
                background-color: #2E76E4;
            }
        }
    }
}

</style>
